import React from 'react';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import Grid from "@material-ui/core/Grid/Grid";
import {Translate} from "../../../config/Translate";
import { VoiceRecorder } from 'react-voice-recorder-player';
import {withStyles} from "@material-ui/core/styles";
import {Styles} from "../../../config/design/styles";
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../config";
import TextField from "@material-ui/core/TextField/TextField";
import LoadingButton from "../../components/elements/LoadingButton";
import {withRouter} from "react-router";
import {withSnackbar} from "notistack";
import {connect} from "trim-redux";
import AppAnimate from "../../components/AppAnimate";
import FormControl from "@material-ui/core/FormControl/FormControl";
import {FormLabel} from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Radio from "@material-ui/core/Radio/Radio";
import FormHelperText from "@material-ui/core/FormHelperText/FormHelperText";
import Container from "@material-ui/core/Container/Container";
import {CheckBoxTwoTone, MicRounded} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography/Typography";
import flower from '../../../files/img/flower.png';
import Button from "@material-ui/core/Button/Button";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import clsx from "clsx";
import Done from "../../../files/img/done.png";
class SubmitReview extends React.Component {
    classes = this.props.classes;
    state = {
        audio:null,
        fields:{
            name:"",
            position:"",
            comment:"",
            satisfaction:0,
        },
        errors:[],
        person_id:this.props.match.params.id,
        person:null,
        loading:true,
        showVoiceRecorder:true,
        SubmitLoading:false,
        done:false,
        disabled:false,
    }
    componentDidMount() {
        this.loadData();
    }
    async loadData(){
        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        await axios.get(`${defaultVariabls.url}/person/get-low-data/${this.state.person_id}`, config)
            .then(response => {
                let person = response.data;
                let {fields} = this.state;
                if(person.type === "person"){
                    fields['name'] = person.name;
                }
                this.setState({
                    person:response.data,
                    fields,
                    loading:false,
                })

            }).catch(error => {
                this.setState({
                    loading:false
                })
            })
    }
    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;
        //name
        if(validator.isEmpty(fields.name)){
            formIsValid = false;
            errors['name'] = Translate.emptyField;
        }
        //name
        if(validator.isEmpty(fields.position)){
            formIsValid = false;
            errors['position'] = Translate.emptyField;
        }
        //name
        if(validator.isEmpty(fields.comment)){
            formIsValid = false;
            errors['comment'] = Translate.emptyField;
        }
        if(fields.satisfaction === 0){
            formIsValid = false;
            errors['satisfaction'] = Translate.emptyField;
        }
        //Description
        if(fields.comment !== null ) {
            if (fields.comment.length > 1000) {
                formIsValid = false;
                errors['comment'] = Translate.maxLength1000;
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { fields,audio,person_id} = this.state;
        let data = new FormData();
        if(!!audio){
            data.append('audio', audio);
        }
        data.append('name', fields.name);
        data.append('position', fields.position);
        data.append('satisfaction', fields.satisfaction);
        data.append('comment', fields.comment);
        data.append('person_id', person_id);

        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        axios.post(`${defaultVariabls.url}/testimonial/make`, data, config)
            .then(response => {
                this.setState({
                    SubmitLoading:false,
                    done:true
                })
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.dataAddingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }
    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleAudio(res){
        let file = new File([res], 'audi.wav');
        this.setState({
            audio:file,
            disabled:false
        })
    }
    handleStartRecording(){
        this.setState({
            disabled:true
        })
    }
    async removeVoice(){
        await this.setState({
            audio:null,
            showVoiceRecorder:false
        }) 
        await this.setState({
            showVoiceRecorder:true
        })
    }
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({fields});
    }
    render() {
            let {SubmitLoading,fields,errors,person,loading,done,showVoiceRecorder} = this.state;
        return (
            <div className={this.classes.rootSubmit}>
                {
                    !loading &&
                    <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.submitReview}>
                        <Container maxWidth='lg'>
                            <Grid container spacing={2}  justifyContent="center">
                                <Grid item xs={12}>
                                    <div className="logo-holder">
                                        <a href={`${defaultVariabls.website}`} target="_blank">
                                            <img className="logo" src={`${defaultVariabls.website}/assets/img/rayanita/logo.png`} alt="Rayanita"/>
                                        </a>
                                        <h1>{Translate.submitReviewFormBy} {person.type === "company" && Translate.co} <strong>{person.type === "person" ? person.name : person.company_name}</strong></h1>

                                    </div>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <div className="sticky-text">
                                        <h2>آیا از همکاری با رایانیتا رضایت داشته اید؟</h2>
                                        <p>لطفا دیدگاه خود را در مورد همکاری با شرکت  رایانیتا ثبت و ما را در مسیر خدمت رسانی بهتر همراهی نمایید.</p>
                                        <p>(دیدگاه شما در بخش نظرات مشتریان قرار خواهد گرفت)</p>
                                        <p>پیشاپیش از شما سپاسگزاریم.</p>
                                        <img src={flower} style={{maxWidth:"100%",marginTop:10}}/>
                                        <div style={{textAlign:"center"}}>

                                        </div>

                                    </div>
                                </Grid>
                                <Grid item xs={12} md={1} />
                                <Grid item xs={12} md={7}>
                                    {
                                        done ?
                                            <div className="form-holder">
                                                <div className='done-holder'>
                                                    <img src={Done} style={{maxWidth:150,marginBottom:20}}/>
                                                    <Typography>با تشکر از شما، اطلاعات فرم ثبت شد!</Typography>
                                                    <Button
                                                        size="small"
                                                        color="secondary"
                                                        varaint="contained"
                                                        component="a"
                                                        href={`${defaultVariabls.website}`}
                                                        >
                                                        بازگشت به سایت
                                                    </Button>
                                                </div>
                                            </div>
                                            :
                                            <div className="form-holder">
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <FormLabel style={{marginBottom:5,marginTop:15,display:"block"}} >لطفا مشخصات خود را وارد نمایید</FormLabel>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            required
                                                            fullWidth
                                                            variant="outlined"
                                                            name="name"
                                                            label={Translate.userName}
                                                            type="text"
                                                            color="secondary"
                                                            value={fields.name}
                                                            onChange={this.handleChange.bind(this)}
                                                            error = {!!errors['name']}
                                                            helperText={errors['name']}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            required
                                                            fullWidth
                                                            variant="outlined"
                                                            color="secondary"
                                                            name="position"
                                                            label={Translate.position}
                                                            type="text"
                                                            value={fields.position}
                                                            onChange={this.handleChange.bind(this)}
                                                            error = {!!errors['position']}
                                                            helperText={errors['position']}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FormLabel style={{marginBottom:5,marginTop:15,display:"block"}} >میزان رضایت از همکاری با ما را تعیین نمایید</FormLabel>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FormControl required error={!!errors['satisfaction']} component="fieldset">
                                                            <RadioGroup style={{display:"flex",alignItems:"center",flexWrap:"wrap",flexDirection:"row"}} aria-label="satisfaction" name="satisfaction" value={fields.satisfaction} onChange={this.handleChange.bind(this)}>
                                                                <FormControlLabel value="5" control={<Radio />} label={Translate.satisfaction5} />
                                                                <FormControlLabel value="4" control={<Radio />} label={Translate.satisfaction4} />
                                                                <FormControlLabel value="3" control={<Radio />} label={Translate.satisfaction3} />
                                                                <FormControlLabel value="2" control={<Radio />} label={Translate.satisfaction2} />
                                                                <FormControlLabel value="1" control={<Radio />} label={Translate.satisfaction1} />
                                                            </RadioGroup>
                                                            <FormHelperText>{errors['satisfaction']}</FormHelperText>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FormLabel style={{marginBottom:5,marginTop:15,display:"block"}} >لطفا در یک پاراگراف نقاط دیدگاه خود را درباره این همکاری بیان کنید</FormLabel>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            required
                                                            fullWidth
                                                            variant="outlined"
                                                            name="comment"
                                                            label={Translate.comment}
                                                            type="text"
                                                            color="secondary"
                                                            multiline
                                                            minRows={5}
                                                            value={fields.comment}
                                                            onChange={this.handleChange.bind(this)}
                                                            error = {!!errors['comment']}
                                                            helperText={errors['comment']}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FormLabel style={{marginBottom:5,marginTop:15,display:"block"}} >لطفا نظر خود را در قالب یک پیام صوتی ثبت نمایید</FormLabel>
                                                    </Grid>
                                                    <Grid item xs={12} lg={7} className={!!this.state.disabled ? "recording" : "paused"}>
                                                        {
                                                            !!showVoiceRecorder &&
                                                            <VoiceRecorder
                                                                downloadable={false}
                                                                mainContainerStyle={styles.mainContainerStyle}
                                                                controllerContainerStyle={styles.controllerContainerStyle}
                                                                controllerStyle={styles.controllerStyle}
                                                                waveContainerStyle={styles.waveContainerStyle}
                                                                onAudioDownload={(res) => this.handleAudio(res)}
                                                                onRecordingStart={() => this.handleStartRecording()}
                                                                width="100%"
                                                            />
                                                        }
                                                       
                                                    </Grid>
                                                    <Grid item xs={12} lg={5}>
                                                        {
                                                            !this.state.audio ?
                                                                <div className={this.classes.voiceTextFlex}>
                                                                    <FormHelperText className="voiceHelper">
                                                                        {Translate.voiceHelper1}
                                                                        <span className="icon-holder">
                                                              <svg className="voice-recorder-icon" width="100px"
                                                                   height="100px" viewBox="0 0 512 512"
                                                                   xmlns="http://www.w3.org/2000/svg"
                                                                   xlink="http://www.w3.org/1999/xlink"
                                                                   fill="#d8d5d5">
                                                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round"
                                                                       stroke-linejoin="round"></g>
                                                                    <g id="SVGRepo_iconCarrier">
                                                                        <title>microphone-filled</title>
                                                                        <g id="Page-1" stroke="none" stroke-width="1"
                                                                           fill="none" fill-rule="evenodd">
                                                                            <g id="icon" fill="#d8d5d5"
                                                                               transform="translate(85.333333, 42.666667)">
                                                                                <path
                                                                                    d="M42.6666667,170.666667 C42.6666667,183.68 47.1466667,298.666667 170.666667,298.666667 C294.186667,298.666667 298.666667,183.68 298.666667,170.666667 L298.666667,170.666667 L341.333333,170.666667 C341.333333,226.346667 309.333333,328.96 192,341.333333 L192,341.333333 L192,426.666667 L149.333333,426.666667 L149.333333,341.333333 C32,328.96 1.42108547e-14,226.346667 1.42108547e-14,170.666667 L1.42108547e-14,170.666667 Z M170.666667,7.10542736e-15 C211.903928,7.10542736e-15 245.333333,33.4294053 245.333333,74.6666667 L245.333333,74.6666667 L245.333333,181.333333 C245.333333,222.570595 211.903928,256 170.666667,256 C150.863835,256 131.872077,248.133356 117.86936,234.13064 C103.866644,220.127923 96,201.136165 96,181.333333 L96,181.333333 L96,74.6666667 C96,33.4294053 129.429405,7.10542736e-15 170.666667,7.10542736e-15 Z"
                                                                                    id="voice"></path>
                                                                            </g>
                                                                        </g>
                                                                    </g>
                                                                </svg>
                                                            </span>
                                                                    </FormHelperText>
                                                                    <FormHelperText className="voiceHelper">
                                                                        {Translate.voiceHelper2}
                                                                        <span className="icon-holder">
                                                                    <svg width="100px" height="100px"
                                                                         xmlns="http://www.w3.org/2000/svg"
                                                                         viewBox="0 0 24 24" id="upload">
                                                                    <path
                                                                        d="M8.71,7.71,11,5.41V15a1,1,0,0,0,2,0V5.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42l-4-4a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-4,4A1,1,0,1,0,8.71,7.71ZM21,12a1,1,0,0,0-1,1v6a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V13a1,1,0,0,0-2,0v6a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V13A1,1,0,0,0,21,12Z"></path>
                                                                </svg>
                                                                </span>
                                                                    </FormHelperText>
                                                                </div>
                                                                :
                                                                <div className={clsx(this.classes.voiceTextFlex,'done')}>
                                                                    <FormHelperText className="voiceHelper done">
                                                                        {Translate.voiceHelperGreen1}
                                                                    </FormHelperText>
                                                                    <Button
                                                                        size="small"
                                                                        style={{color: "rgb(255 78 99)"}}
                                                                        onClick={() => this.removeVoice()}
                                                                        startIcon={<CloseRoundedIcon style={{color: "rgb(255 78 99)"}}/>}
                                                                    >
                                                                        حذف پیام
                                                                    </Button>
                                                                </div>
                                                            
                                                        }

                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <LoadingButton
                                                            variant="contained"
                                                            color="secondary"
                                                            onClick = {this.handleSubmit.bind(this)}
                                                            loading = {SubmitLoading}
                                                            size="large"
                                                            disabled={this.state.disabled}
                                                            startIcon={<CheckRoundedIcon color="primary"/>}
                                                        >
                                                            {Translate.submitReview}
                                                        </LoadingButton>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                    }

                                </Grid>
                            </Grid>
                        </Container>
                    </AppAnimate>
                }
            </div>

        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(SubmitReview))));
const styles = {
    mainContainerStyle: {
        boxShadow:"none",
        margin:0,
        borderRadius:4
    },
    controllerContainerStyle: {
        background:"#001131",
        borderTop:0,
    },
    controllerStyle: {

    },
    waveContainerStyle: {
        background:"#00091a"
    }
};
